import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import './SideNavigationMenu.scss';
import { FaIcon, FaIcons } from '@innovationnorway/component-library';
import { useTranslation } from 'react-i18next';
import TertiaryButton from 'src/components/TertiaryButton/TertiaryButton';
import Tooltip from 'src/components/Tooltip/Tooltip';
import Divider from 'src/components/Divider';

type SideNavigationMenuProps = {
  backButtonPath?: string;
  routerLinks: RouterLinks[];
  className?: string;
  collapsable?: boolean;
};

export type RouterLinks = {
  id: number;
  isVisible: boolean;
  to: string;
  icon?: IconLookup;
  textContent: string;
  exact?: boolean;
  state?: { [key: string]: string };
};

const SideNavigationMenu: React.FC<SideNavigationMenuProps> = ({
  backButtonPath,
  routerLinks,
  className,
  collapsable = true,
}) => {
  const { t: tCommon } = useTranslation();
  const [show, setShow] = useState(true);

  return (
    <aside className={`side-navigation-menu ${className || ''}`}>
      <nav className="side-navigation-menu__buttons center stack-medium padding-top--2">
        {backButtonPath && (
          <Link to={backButtonPath} className={`${show ? 'text-align--left' : ''} margin-bottom--6`}>
            <div>
              <FaIcon name={FaIcons.ArrowLeft} className="margin-right--1" />{' '}
              {show && <u>{tCommon('back')}</u>}
            </div>
          </Link>
        )}

        {routerLinks.map((routerLink) => {
          if (routerLink.isVisible) {
            return (
              <Tooltip disable={show} key={routerLink.id} direction="right" text={routerLink.textContent}>
                <NavLink
                  to={routerLink.to}
                  end={routerLink.exact}
                  className={`${show ? 'text-align--left' : ''} display--flex`}
                  state={routerLink.state}
                >
                  {routerLink.icon !== undefined && (
                    <div className={`margin-y--auto ${!show && 'margin-x--auto'}`}>
                      <FaIcon
                        className="vertical-align--icon align-self--baseline"
                        size="1x"
                        icon={icon(routerLink.icon)}
                      />
                    </div>
                  )}
                  {show && <span className="">{routerLink.textContent}</span>}
                </NavLink>
              </Tooltip>
            );
          }
        })}
        {collapsable && (
          <>
            <Divider className="margin-top--3" />
            <Tooltip disable={show} direction="right" text={tCommon('showMore')}>
              <TertiaryButton
                faIcon={show ? FaIcons.AngleDoubleLeftLight : FaIcons.AngleDoubleRightLight}
                minimalPadding
                onClick={() => setShow(!show)}
                className={show ? 'open' : ''}
              >
                {show && tCommon('showLess')}
              </TertiaryButton>
            </Tooltip>
          </>
        )}
      </nav>
    </aside>
  );
};

export default SideNavigationMenu;
